import { useEffect } from 'react'

const APP_NAME = 'Short Circuit'

/**
 * Set document.title for the current route. Restores the previous title
 * on unmount, so leaving a sub-page doesn't strand its title in the tab.
 *
 *   useDocumentTitle('Projects')      // → "Projects — Short Circuit"
 *   useDocumentTitle()                // → "Short Circuit" (default app title)
 *
 * Pass `null` or omit to reset to the bare app name (useful from auth-gated
 * landing components that don't have a specific section).
 */
export default function useDocumentTitle(pageTitle) {
  useEffect(() => {
    const previous = document.title
    document.title = pageTitle ? `${pageTitle} — ${APP_NAME}` : APP_NAME
    return () => {
      document.title = previous
    }
  }, [pageTitle])
}
